// extracted by mini-css-extract-plugin
module.exports = {"pill":"CountPillGrey_pill__11Zio"};